import React, { useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import { Box, Flex, Span, Text } from "../../assets/ui";
import Theme from "../../assets/ui/theme";
import {
  Line1Icon,
  Line1DesktopIcon,
  Line2DesktopIcon,
  Line3DesktopIcon,
  Line2Icon,
  Line3Icon,
  PlayVideoIcon,
} from "../../assets/icons";
import {
  BannerImage,
  StyledBannerWrapper,
  StyledLineDesktopIcon,
  StyledLineIcon,
  StyledPlayButton,
  StyledVideoWrapper
} from "./ui";
import ScrollDown from "../../components/common/ScrolDown";

const Banner = props => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const video = useRef(null);

  const openVideo = () => {
    setShowVideoModal(true);
  };

  const handleClose = e => {
    e.stopPropagation();
    setShowVideoModal(false);
  };

  return (
    <Flex
      height="100%"
      alignItems={["center", "flex-start", null]}
      justifyContent="center"
      borderBottom={["1px solid rgba(58,79,106,0.2)", null, null, "none"]}
      overflow={"hidden"}
    >
      {showVideoModal && (
        <StyledVideoWrapper>
          <Box position="relative">
            <Span
              position="absolute"
              zIndex="2"
              cursor="pointer"
              width="24px"
              height="24px"
              top="20px"
              right="20px"
              onClick={handleClose}
            >
              <MdClose size="24px" color={Theme.colors.mainPink} />
            </Span>
            <video id="background-video" ref={video} controls>
              <source
                src="https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/Exsportia%20Hype%20video_1.mp4?alt=media&token=0c82dcb6-f0eb-432e-98f0-215e10fab028"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </Box>
        </StyledVideoWrapper>
      )}

      <StyledBannerWrapper>
        <Flex
          fontWeight="bold"
          flexDirection="column"
          alignItems={["center", "flex-start"]}
          marginBottom={"60px"}
          textAlign={["center", "start"]}
          lineHeight={["42px", null, "72px"]}
          fontSize={["36px", null, "64px"]}
          color={Theme.colors.white}
        >
          <Text>Unleash your inner athlete</Text>
          <Box fontSize={["24px", "40px"]}>
            <Text color={Theme.colors.mainPink}> Sports</Text>
            <Text> is now. </Text>
          </Box>
        </Flex>
        <Box marginBottom={"91px"}>
          <StyledPlayButton
            background={Theme.colors.mainPink}
            color={Theme.colors.white}
            onClick={openVideo}
          >
            <span>
              <PlayVideoIcon />
            </span>
            Play video
          </StyledPlayButton>
        </Box>
        <ScrollDown />
      </StyledBannerWrapper>
      <StyledLineIcon index={1}>
        <Line1Icon />
      </StyledLineIcon>
      <StyledLineIcon index={2}>
        <Line2Icon />
      </StyledLineIcon>
      <StyledLineIcon index={3}>
        <Line3Icon />
      </StyledLineIcon>
      <StyledLineDesktopIcon index={1}>
        <Line1DesktopIcon />
      </StyledLineDesktopIcon>
      <StyledLineDesktopIcon index={2}>
        <Line2DesktopIcon />
      </StyledLineDesktopIcon>
      <StyledLineDesktopIcon index={3}>
        <Line3DesktopIcon />
      </StyledLineDesktopIcon>
      <BannerImage />
    </Flex>
  );
};

export default Banner;
